import React from 'react'
import Component from '../common/Component'
import LevelFundedBenefitsSetComponent from './LevelFundedBenefitsSetComponent'
import { benefitNames } from './fields'
import BenefitsSetForm from '../BenefitsSet/BenefitsSetForm'

export default class LevelFundedBenefitsSetForm extends Component {
  render() {
    return (
      <BenefitsSetForm
        benefitNames={benefitNames}
        benefitsSetComponent={LevelFundedBenefitsSetComponent}
        productLine="Medical"
        {...this.props}
      />
    )
  }
}
